//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.FilterSearchResponse
import com.tixforgigs.apax.models.FilterSearchType
import com.tixforgigs.apax.models.TemplateConfig
import com.tixforgigs.apax.models.TemplateCreateRequest
import com.tixforgigs.apax.models.TemplateListResponse

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonTemplateApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * ... - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @param templateId 
     * @return TemplateConfig
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateConfigGet(templateId: kotlin.uuid.Uuid): HttpResponse<TemplateConfig> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/template/config/{templateId}".replace("{" + "templateId" + "}", "$templateId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Update a template config. - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @param templateId 
     * @param templateConfig 
     * @return TemplateConfig
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateConfigUpdate(templateId: kotlin.uuid.Uuid, templateConfig: TemplateConfig): HttpResponse<TemplateConfig> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = templateConfig

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/template/config/{templateId}".replace("{" + "templateId" + "}", "$templateId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * ... - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @param templateCreateRequest 
     * @return TemplateConfig
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateCreate(templateCreateRequest: TemplateCreateRequest): HttpResponse<TemplateConfig> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = templateCreateRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/template/config",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * ... - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @param templateId 
     * @return void
     */
    open suspend fun templateDelete(templateId: kotlin.uuid.Uuid): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.DELETE,
            "/template/config/{templateId}".replace("{" + "templateId" + "}", "$templateId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * ... - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @return TemplateListResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateListGet(): HttpResponse<TemplateListResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/template/config",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * ... - EXPERIMENTAL (version from:4.6 to:latest)
     * ...
     * @param query The search text
     * @param type The search type
     * @return FilterSearchResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateSearch(query: kotlin.String, type: FilterSearchType): HttpResponse<FilterSearchResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        query?.apply { localVariableQuery["query"] = listOf("$query") }
        type?.apply { localVariableQuery["type"] = listOf("${ type.value }") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/template/search",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * ... - BETA (version from:4.6 to:latest)
     * ...
     * @param templateId 
     * @return kotlin.String
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun templateStyle(templateId: kotlin.uuid.Uuid): HttpResponse<kotlin.String> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/template/style/{templateId}".replace("{" + "templateId" + "}", "$templateId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


}
